import utils from '@/mixins/utils.js'

export const dataFields = {
  Vacina: 'no_imuno',
  Dose: 'no_dose_imuno',
  Aplicação: 'dt_aplicacao',
  Atendimento: 'dt_atendimento',
  'Nascimento FV': 'dt_nascimento_vacinacao',
  Profissional: 'profissional',
  Cidadão: 'no_cidadao',
  'Nascimento FCI': 'dt_nascimento_cidadao',
  Mãe: 'no_mae',
}
